import moment from "moment/moment";
import {DateFormats} from "../../../components/constants/securspace-constants";
import request from "../../../util/SuperagentUtils";
import { buyerSpaceUsageReportEndpoints } from "../../api-endpoints";
import {SuperAgentRequest} from "superagent";
import {MomentInput} from "moment";
import {getUrlSearchParamsByPaging} from "../../../util/UrlPagingParamUtils";

type BuyerSpaceUsageRequestsParams = {
  page?: number
  size?: number
  startDate?: MomentInput
  endDate?: MomentInput
  locationId?: string
  locationName?: string
  bookingNumber?: string
  invoiceNumber?: string
  sortBy?: string
  sortDir?: string
  groupBy?: string
}

export const getSpaceUsageUrlParams = (requestParams: BuyerSpaceUsageRequestsParams, isPageable: boolean) => {

  const {page, size, startDate, endDate, locationId, locationName, bookingNumber, invoiceNumber, sortBy, sortDir, groupBy} = requestParams;

  const params = isPageable ? getUrlSearchParamsByPaging(page, size) : new URLSearchParams();

  if (startDate) {
    params.append("startDate", moment(startDate).format(DateFormats.DAY));
  }
  if (endDate) {
    params.append("endDate", moment(endDate).format(DateFormats.DAY));
  }
  if (locationId) {
    params.append("locationId", locationId)
  }
  if (locationName && !isPageable) {
    params.append("locationName", locationName)
  }
  if (bookingNumber) {
    params.append("bookingNumber", bookingNumber)
  }
  if (invoiceNumber) {
    params.append("overageInvoiceNumber", invoiceNumber)
  }
  if (sortBy) {
    params.append("sortBy", sortBy)
  }
  if (sortDir) {
    params.append("sortDir", sortDir)
  }
  if (groupBy) {
    params.append("groupBy", groupBy)
  }

  return params;
}

export const requestBuyerSpaceUsagePaginated = (searchParams: {},
                                                onSuccess?: () => void,
                                                onFail?: (err: Object) => void): SuperAgentRequest | void => {
  const result = request.get(`${buyerSpaceUsageReportEndpoints.search}?${getSpaceUsageUrlParams(searchParams, true)}`);

  if(onSuccess && onFail) {
    result
      .then(onSuccess)
      .catch(onFail)
  } else {
    return result
  }
}

export const getBuyerSpaceUsageReportUrl = (searchParams: BuyerSpaceUsageRequestsParams) => {
  return `${buyerSpaceUsageReportEndpoints.report}?${getSpaceUsageUrlParams(searchParams, false)}`;
}

export const getBuyerSpaceUsageGroupSummaryUrl = (searchParams: BuyerSpaceUsageRequestsParams) => {
  const summaryParams = {
    startDate: searchParams.startDate,
    endDate: searchParams.endDate,
    locationId: searchParams.locationId,
    locationName: searchParams.locationName,
    groupBy: searchParams.groupBy
  }

  return `${buyerSpaceUsageReportEndpoints.group}?${getSpaceUsageUrlParams(summaryParams, false)}`;
}

export const requestCalculateBuyerSpaceUsageSummary = async (searchParams: BuyerSpaceUsageRequestsParams) => {
  return await request.get(`${buyerSpaceUsageReportEndpoints.summary}?${getSpaceUsageUrlParams(searchParams, false)}`);
}
